module.exports = __webpack_public_path__ + "img/weibo.05f3bb15.png";